const transactionsDetails = (state = null, action) => {
  if (action.type === "SET_TRANSACTIONS_DETAILS") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_TRANSACTIONS_DETAILS": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default transactionsDetails;
